var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoucherIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0.5 0.89 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7409222_voucher_icon",
    clipPath: "url(#clip0_196_12896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Voucher"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23 (Stroke)",
    d: "M2.16659 5.16904C1.30594 5.16904 0.608252 5.86673 0.608252 6.72738V8.39404C0.608252 8.79445 0.932845 9.11904 1.33325 9.11904C1.73366 9.11904 2.05825 8.79445 2.05825 8.39404V6.72738C2.05825 6.66755 2.10676 6.61904 2.16659 6.61904H18.8333C18.8931 6.61904 18.9416 6.66754 18.9416 6.72738V8.39404C18.9416 8.79445 19.2662 9.11904 19.6666 9.11904C20.067 9.11904 20.3916 8.79445 20.3916 8.39404V6.72738C20.3916 5.86673 19.6939 5.16904 18.8333 5.16904H2.16659ZM2.05825 14.2274C2.05825 13.827 1.73366 13.5024 1.33325 13.5024C0.932844 13.5024 0.608252 13.827 0.608252 14.2274V15.894C0.608252 16.7547 1.30594 17.4524 2.16659 17.4524H18.8333C19.6939 17.4524 20.3916 16.7547 20.3916 15.894V14.2274C20.3916 13.827 20.067 13.5024 19.6666 13.5024C19.2662 13.5024 18.9416 13.827 18.9416 14.2274V15.894C18.9416 15.9539 18.8931 16.0024 18.8333 16.0024H2.16659C2.10675 16.0024 2.05825 15.9539 2.05825 15.894V14.2274Z",
    fill: "#009A46",
    stroke: "#009A46",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 10 (Stroke)",
    d: "M17.0583 11.3107C17.0583 10.1003 18.0395 9.11904 19.2499 9.11904C19.6503 9.11904 19.9749 8.79445 19.9749 8.39404C19.9749 7.99364 19.6503 7.66904 19.2499 7.66904C17.2387 7.66904 15.6083 9.29948 15.6083 11.3107C15.6083 13.3219 17.2387 14.9524 19.2499 14.9524C19.6503 14.9524 19.9749 14.6278 19.9749 14.2274C19.9749 13.827 19.6503 13.5024 19.2499 13.5024C18.0395 13.5024 17.0583 12.5211 17.0583 11.3107Z",
    fill: "#009A46",
    stroke: "#009A46",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 11 (Stroke)",
    d: "M1.33325 7.66904C0.932845 7.66904 0.608252 7.99364 0.608252 8.39404C0.608252 8.79445 0.932845 9.11904 1.33325 9.11904C2.54367 9.11904 3.52492 10.1003 3.52492 11.3107C3.52492 12.5211 2.54367 13.5024 1.33325 13.5024C0.932844 13.5024 0.608252 13.827 0.608252 14.2274C0.608252 14.6278 0.932844 14.9524 1.33325 14.9524C3.34449 14.9524 4.97492 13.3219 4.97492 11.3107C4.97492 9.29948 3.34449 7.66904 1.33325 7.66904Z",
    fill: "#009A46",
    stroke: "#009A46",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 28 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.269C8.34517 15.269 8.625 15.5489 8.625 15.894V16.7274C8.625 17.0725 8.34517 17.3524 8 17.3524C7.65483 17.3524 7.375 17.0725 7.375 16.7274V15.894C7.375 15.5489 7.65483 15.269 8 15.269Z",
    fill: "#009A46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 29 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.9357C8.34517 11.9357 8.625 12.2156 8.625 12.5607V13.3941C8.625 13.7392 8.34517 14.0191 8 14.0191C7.65483 14.0191 7.375 13.7392 7.375 13.3941V12.5607C7.375 12.2156 7.65483 11.9357 8 11.9357Z",
    fill: "#009A46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 30 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.60236C8.34517 8.60236 8.625 8.88218 8.625 9.22736V10.0607C8.625 10.4059 8.34517 10.6857 8 10.6857C7.65483 10.6857 7.375 10.4059 7.375 10.0607V9.22736C7.375 8.88218 7.65483 8.60236 8 8.60236Z",
    fill: "#009A46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 31 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.26904C8.34517 5.26904 8.625 5.54887 8.625 5.89404V6.72738C8.625 7.07255 8.34517 7.35238 8 7.35238C7.65483 7.35238 7.375 7.07255 7.375 6.72738V5.89404C7.375 5.54887 7.65483 5.26904 8 5.26904Z",
    fill: "#009A46"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_12896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.894043)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIcon);
export default __webpack_public_path__ + "static/media/voucher-icon.0f95978507496d9b6b6022d8bfc732f8.svg";
export { ForwardRef as ReactComponent };